import React from 'react'
import Gallery from '../../components/Gallery'
import SEO from '../../components/SEO'
import SubMenu from '../../components/SubMenu'

const TravelPage = ({ data, transition }) => (
  <div>
    <SubMenu thisName={'Travel'} />
    <div style={transition && transition.style}>
      <SEO slug={'Travel'} />
      <Gallery sizes={data.travel.edges} />
    </div>
  </div>
)

export default TravelPage



// WEBPACK FOOTER //
// ./src/pages/travel/index.js